module.exports = __webpack_public_path__ + "static/img/leaf.55c9f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/leaf.png
// module id = IiCy
// module chunks = 0